import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap5';
import { Link, useParams, useNavigate } from 'react-router-dom';
import routes from 'app/routes';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import usePlan from 'components/Common/PolicyPlans/Hooks/usePlan';
import Alert from 'components/new_ui/Alerts/alert';
import { useContext as usePlansContext } from 'components/Managers/Policy/Context';
import Summary from '../Widgets/Summary';

import ActivateModal from '../Widgets/ActivateModal';
import Actions from '../../Actions';

export default function Index({ enterpriseId }) {
  const { state: statePlans } = usePlansContext();

  const { planId } = useParams();
  const [showActivation, setShowActivation] = useState(false);

  const [plan, setPlan] = useState(null);
  const { plan: originalPlan } = usePlan(enterpriseId, planId);

  const navigate = useNavigate();

  useEffect(() => {
    setPlan(originalPlan);
  }, [originalPlan]);

  const onClick = () => {
    if (plan.attributes.possible_activate) {
      setShowActivation(true);
    } else {
      Alert({
        title: 'Activation',
        text: `We are unable to activate your plan at the moment. 
        Please ensure that you have an active Platform Plan before proceeding 
        with the activation of a Professional or Executive Plan. 
        To begin, please activate a Platform Plan.`,
        confirmButtonText: 'Close',
      });
    }
  };

  const onActivate = () => {
    Actions.activatePlan(plan.attributes.enterprise_id, planId, (savedPlan) => {
      navigate(
        routes.managers.plans.activated(planId),
        {
          state: { plan: savedPlan },
        },
      );
    });
  };

  return (
    <div className="content">
      <section>
        <h1 className="mb-3">Summary</h1>

        <p>This is the summary of Talent Insurance Policy.</p>
      </section>

      {plan === null ? (
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      ) : (
        <>
          <Summary plan={plan} />

          <footer>
            <Link
              to={routes.managers.policy.index}
              className="btn btn-outline-primary"
            >
              Close
            </Link>

            {plan.attributes.status === 'draft' && (
              <Button disabled={statePlans.enterprise.attributes.is_lock} onClick={onClick}>
                Activate
              </Button>
            )}
          </footer>

          <ActivateModal
            show={showActivation}
            plan={plan}
            onClose={() => setShowActivation(false)}
            onActivate={onActivate}
          />
        </>
      )}
    </div>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
